import { Container, Row } from "reactstrap";
import GridOptions from "./GridOptions";
import { Breadcrumbs } from "../../../AbstractElements";
import { Grid, UiKits } from "../../../Constants/Constants";
import GridColumn from './GridColumn'
import VerticalAlignment from './VerticalAlignment'
import HorizontalAlignment from './HorizontalAlignment'
import Nesting from './Nesting'
import Order from './Order'
import OffSet from './OffSet'

const GridContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Grid} parent={UiKits} />
      <Container fluid>
        <Row>
          <GridOptions />
          <GridColumn/>
          <VerticalAlignment/>
          <HorizontalAlignment/>
          <Nesting/>
          <Order/>
          <OffSet/>
        </Row>
      </Container>
    </>
  );
};
export default GridContainer;
